module.exports = __webpack_public_path__ + "img/palava.78af3acc.svg";